import React, { useEffect, useRef, useState } from "react";
import Page from "../../types/Page";
import Layout from "../../components/Layout";
import PageHeader from "../../components/PageHeader";
import {
  Button,
  Card,
  Col,
  Form,
  ListGroup,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useSearchParams } from "react-router-dom";
import InfoWebCoreApi from "../../common/infoweb/infoWebCoreApi";
import { SearchResult } from "../../types/InfoWebTypes";

const SupportSearchPageType: Page = {
  ActiveTab: "support",
  DisplayName: "Hae ohjeista",
  LinkUrl: "/support/search",
  Path: "/support/search",
  RouteName: "support-search",
};

const SupportSearchPage = () => {
  const [results, setResults] = useState<SearchResult[]>();
  const searchInput = useRef<HTMLInputElement>();
  const [startPageId, setStartPageId] = useState<string>();
  const [initialQuery, setInitialQuery] = useState<string>();
  const [showSpinner, setShowSpinner] = useState<boolean>();

  useEffect(() => {
    const fetchData = async () => {
      var startPage = await InfoWebCoreApi.GetPageByPathAsync(
        "fi/asiakaspalvelu/usein-kysyttya",
      );

      if (startPage != null) {
        setStartPageId(startPage.contentItemId);
        setInitialQuery(new URLSearchParams(window.location.search).get("q"));
      }
    };

    fetchData().catch(console.error);
  }, []);

  useEffect(() => {
    if (initialQuery) {
      searchInput.current.value = initialQuery;

      const fetchData = async () => {
        await doSearch();
      };

      fetchData().catch(console.error);
    }
  }, [initialQuery]);

  const onKeyUp = async (e: any) => {
    if (e.key == "Enter") {
      await doSearch();
    }
  };

  const doSearch = async () => {
    var q = searchInput.current.value;

    setResults(null);

    if (q) {
      setShowSpinner(true);
      var results = await InfoWebCoreApi.SearchAsync("fi", startPageId, q);
      setResults(results);
    }

    setShowSpinner(false);
  };

  return (
    <div className={SupportSearchPageType.RouteName}>
      <Layout CurrentPage={SupportSearchPageType}>
        <PageHeader
          Title={SupportSearchPageType.DisplayName}
          SubTitle={SupportSearchPageType.DisplayParentName}
          Back={true}
          Icon="search"
        ></PageHeader>

        {startPageId && (
          <>
            <div className="position-relative col-12 col-lg-6 my-24">
              <Form.Control
                placeholder="Hae ohjeista..."
                ref={searchInput}
                onKeyUp={onKeyUp}
              />
              <Button
                variant="link"
                className="pe-none position-absolute end-0 top-0"
                id="button-addon2"
              >
                <span className="bi bi-search"></span>
              </Button>
            </div>

            {showSpinner && (
              <div className={""}>
                <Spinner animation="border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </div>
            )}

            {results?.length > 0 && (
              <ListGroup className="bg-white">
                {results.map((result, index) => {
                  return (
                    <ListGroup.Item key={"sr-" + result.contentItemId}>
                      <Link
                        className="fw-bold"
                        to={"https://www.lomarengas.fi" + result.path}
                        target="_blank"
                      >
                        {result.title}
                      </Link>
                      {result.resultText && (
                        <i
                          className="d-block"
                          dangerouslySetInnerHTML={{
                            __html: result.resultText,
                          }}
                        ></i>
                      )}
                    </ListGroup.Item>
                  );
                })}
              </ListGroup>
            )}
          </>
        )}
      </Layout>
    </div>
  );
};

export default SupportSearchPage;
